import React, {useContext, useEffect} from 'react';
import Dropzone from "../../../../../../components/dropzone/dropzone.jsx";
import {IndividualContext} from "../../individual-context.jsx";
import {isImageAttach} from "../../resources/attach-utils.js";

const Attachments = () => {
    const {individual, setChanges, setAttachList, attachList, attachesDescription, setAttachesDescription, setIndividual} = useContext(IndividualContext)

    useEffect(() => {
        setIndividual(prev => ({
            ...prev,
            attachs: attachList.filter(a => !a.new)
        }))
    }, [attachList]);

    return (
        <Dropzone
            attaches={attachList.filter(a => a.attachId !== individual.relatedPhotoFaceId && !isImageAttach(a))}
            setAttaches={(prev) => {
                setChanges(prev => (prev.includes("attachments") ? prev : [...prev, "attachments"]))
                setAttachList(prev)
            }}
            attachesDescription={attachesDescription}
            setAttachesDescription={setAttachesDescription}
            accept={"application/pdf"}
        />
    );
};

export default Attachments;